const SET_SUPER_OFFERS_IMPRESSIONS_SENT = 'SET_SUPER_OFFERS_IMPRESSIONS_SENT';
const SET_DAILY_SPECIALS_IMPRESSIONS_SENT = 'SET_DAILY_SPECIALS_IMPRESSIONS_SENT';
const SET_APPLY_TO_IMPRESSIONS_SENT = 'SET_APPLY_TO_IMPRESSIONS_SENT';


const setSuperOffersImpressionsSent = sent => ({
  type: SET_SUPER_OFFERS_IMPRESSIONS_SENT,
  payload: sent
});

const setDailySpecialsImpressionsSent = sent => ({
  type: SET_DAILY_SPECIALS_IMPRESSIONS_SENT,
  payload: sent
});

const setApplyToImpressionsSent = sent => ({
  type: SET_APPLY_TO_IMPRESSIONS_SENT,
  payload: sent
});

export {
  SET_SUPER_OFFERS_IMPRESSIONS_SENT,
  SET_DAILY_SPECIALS_IMPRESSIONS_SENT,
  SET_APPLY_TO_IMPRESSIONS_SENT,
  setSuperOffersImpressionsSent,
  setDailySpecialsImpressionsSent,
  setApplyToImpressionsSent
};
